import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import api, { API } from "@/lib/api";

const PUBLIC_BASE = API.replace(/\/api\/?$/, "");

export async function elementToPdfBase64(el) {
  if (document.fonts && document.fonts.ready) {
    try { await document.fonts.ready; } catch { /* noop */ }
  }
  const canvas = await html2canvas(el, { scale: 2, useCORS: true, backgroundColor: "#ffffff", logging: false });
  const img = canvas.toDataURL("image/jpeg", 0.92);
  const pdf = new jsPDF("p", "mm", "a4");
  const pw = pdf.internal.pageSize.getWidth();
  const ph = pdf.internal.pageSize.getHeight();
  const imgH = (canvas.height * pw) / canvas.width;
  let heightLeft = imgH;
  let position = 0;
  pdf.addImage(img, "JPEG", 0, position, pw, imgH);
  heightLeft -= ph;
  while (heightLeft > 0) {
    position -= ph;
    pdf.addPage();
    pdf.addImage(img, "JPEG", 0, position, pw, imgH);
    heightLeft -= ph;
  }
  return pdf.output("datauristring").split(",")[1];
}

export async function uploadDocument(bookingId, type, el) {
  const pdf_base64 = await elementToPdfBase64(el);
  const { data } = await api.post(`/bookings/${bookingId}/document`, {
    type, channel: "whatsapp", pdf_base64, public_base: PUBLIC_BASE,
  });
  return data;
}

export function buildWhatsAppUrl(publicUrl, type, phone, guestName) {
  const label = type === "ricevuta" ? "la ricevuta" : "il voucher";
  const msg = `Gentile ${guestName || "ospite"}, di seguito ${label} della sua prenotazione presso Blu Lodge Maldives:\n${publicUrl}`;
  const digits = (phone || "").replace(/[^0-9]/g, "");
  return `https://wa.me/${digits}?text=${encodeURIComponent(msg)}`;
}

export async function sendViaEmail(bookingId, type, el, recipientEmail) {
  const pdf_base64 = await elementToPdfBase64(el);
  const { data } = await api.post(`/bookings/${bookingId}/document`, {
    type, channel: "email", pdf_base64, public_base: PUBLIC_BASE, recipient_email: recipientEmail || "",
  });
  return data;
}

export async function sendViaWhatsApp(bookingId, type, el, phone, guestName) {
  const data = await uploadDocument(bookingId, type, el);
  window.open(buildWhatsAppUrl(data.public_url, type, phone, guestName), "_blank");
  return data;
}
